// 作り直した歩き (DEV ?lunaWalk=new|newslow・src/player_walk_new.ts) の描画側。 render.ts の drawPlayer から呼ぶ。
//   ① 歩いているかは体の速さ (player.walkVx) で決める = 止まったら次のコマで止まる (今の歩きは止まった後 0.15 秒、足だけ歩き続ける)。
//   ② 歩きの絵の時計を進んだ距離で進める = 着いている足が床に対して動かない (速さが変わっても・加速の途中でも)。
//   ③ 止まった時は、浮いていた足を立ち姿の位置へ下ろす1歩 (着いていた足は床に残す)。 離れすぎた足はもう1歩で寄せる。
//   配布版 (指定なし) では呼ばれない。
import { setNextSpinePlayerAnimDt, setNextSpinePlayerLegOverride, spinePlayerTrack } from './spine_player'
import {
  advanceStopPlan, lunaWalkAnimNames, lunaWalkCycleSec, lunaWalkGait, lunaWalkNewArt, makeStopPlan, stopPose, type StopPlan,
} from './player_walk_new'
import type { Player } from './types'

let lastX: number | null = null
let stopPlan: StopPlan | null = null

export function resetWalkNewDraw(): void {
  lastX = null
  stopPlan = null
}

/** 歩いているか・向き (+1 = ワールド右)。 比較版でない時は null (今の判定を使う) */
export function walkNewAnimState(p: Player): { isWalking: boolean, dirSign: number } | null {
  if (!lunaWalkNewArt()) return null
  const v = p.walkVx ?? 0
  return { isWalking: p.state === 'idle' && Math.abs(v) > 1, dirSign: v === 0 ? 1 : Math.sign(v) }
}

/**
 * drawSpinePlayer の直前に呼ぶ。 walking = この コマで歩きの絵を出すか・neutral = 立ち姿 (上書きなし) を出すか。
 */
export function prepareWalkNewDraw(p: Player, walking: boolean, neutral: boolean, frameDt: number): void {
  if (!lunaWalkNewArt()) return
  const dx = lastX === null ? 0 : Math.abs(p.x - lastX)
  lastX = p.x
  if (walking) {
    stopPlan = null
    // 絵は 160px/秒で1周 (2歩) 進む前提で作ってある → 進んだ距離 / 160 秒だけ進める (v3 の小走りも 160 前提)
    setNextSpinePlayerAnimDt(dx / lunaWalkGait().speedPxPerSec)
    return
  }
  if (!stopPlan && neutral) {
    // 歩きの絵から立ち姿へ移る最初のコマ: 直前まで流していた歩きの位相から1歩を組む
    const track = spinePlayerTrack()
    const names = lunaWalkAnimNames()   // 1 版目 walk_n・2 版目 walk_v2 (脚と1周の長さは同じ)・3 版目 walk_v3 (小走り・1周の長さが違う)
    if (track && (track.name === names.forward || track.name === names.back)) {
      const cycle = lunaWalkCycleSec()
      const phase = (track.time % cycle) / cycle
      stopPlan = makeStopPlan(phase, track.name === names.forward ? 1 : -1, lunaWalkGait())
      const pose = stopPose(stopPlan)
      if (pose) setNextSpinePlayerLegOverride(pose)
      return
    }
  }
  if (stopPlan) {
    const wasFading = stopPlan.fading
    stopPlan = advanceStopPlan(stopPlan, frameDt, neutral)
    const pose = stopPlan && stopPose(stopPlan)
    if (pose) setNextSpinePlayerLegOverride(pose)
    // 立ち姿 (idle) は足の的を動かさない = 最後に書いた値が残る。 1歩が終わったら立ち姿の位置 (setup) ちょうどへ置く
    else if (!wasFading && neutral) setNextSpinePlayerLegOverride({ front: { x: 0, y: 0 }, back: { x: 0, y: 0 }, hipYMax: Infinity, torsoAdd: 0, weight: 1 })
  }
}
